import ISearchService from "../../spi/ISearchService";
import axios from 'axios';
import { getCurrentTenant } from '../../../configs/dbConfigs' 
import { IDocumentFilter } from "../../../types/IDocument";
import bodybuilder from 'bodybuilder';
import { IActivityFilter, IActivityType } from "../../../types/IActivity";
import moment from "moment";
import ITenant from "../../../types/ITenant";
import { ICustomerFilter } from "../../../types/ICustomer";

const API_HOST = 'http://34.71.129.187:9200';
const TENANT:ITenant = getCurrentTenant();

export default class ElasticSearchService implements ISearchService {
    tenantId:string;
    constructor(){
        this.tenantId = 'tenant_'+TENANT.tenantId;
    }

    async searchDocuments( rowsPerPage: number = 3, pageNumber: number = 0, filter?: IDocumentFilter) {
        const options = bodybuilder();
        options.query('match', 'tenantId.keyword', this.tenantId);
        if(filter != null){
            if(filter.searchTerm){
                options.query('match_phrase_prefix', 'name', filter.searchTerm)
            }
            if(filter.category && filter.category !== 'ALL'){
                options.filter('term', 'category.keyword', filter.category)
            }
            if (filter.contentTypes) {
                const contentTypes = filter.contentTypes.filter(item => item !== 'ALL')
                if(contentTypes.length > 0)
                    options.query('terms', 'contentType.keyword', contentTypes)
            }

            if(filter.sortBy){
                if(filter.sortBy == 'name')
                    options.sort('name.keyword', 'asc');
                else if(filter.sortBy == 'size')
                    options.sort('size', 'asc');
            }
        }
        
        const opt = options.size(rowsPerPage).from(rowsPerPage*pageNumber).build();
        return axios.post(API_HOST +'/documents/document/_search', opt);
    }    

    async searchCustomers( rowsPerPage: number = 3, pageNumber: number = 0, filter?: ICustomerFilter) {
        const options = bodybuilder();
        options.query('match', 'tenantId.keyword', this.tenantId);
        if(filter != null){
            if(filter.searchTerm){
                options.query('match_phrase_prefix', 'account.firstName', filter.searchTerm)
            }
            if(filter.timeline && filter.timeline !== 'ALL'){
                options.filter('term', 'timeline.keyword', filter.timeline)
            }
            if (filter.activities) {
                if(filter.activities.length > 0)
                    options.query('terms', 'activities.keyword', filter.activities)
            }

            /*if(filter.sortBy){
                if(filter.sortBy == 'name')
                    options.sort('name.keyword', 'asc');
                else if(filter.sortBy == 'size')
                    options.sort('size', 'asc');
            }*/
        }

        const opt = options.size(rowsPerPage).from(rowsPerPage*pageNumber).build();
        return axios.post(API_HOST +'/customers/customer/_search', opt);
    }

    async searchActivities(rowsPerPage: number = 3, pageNumber: number = 0, filter?: IActivityFilter){
        const options = bodybuilder();
        options.addFilter('match', 'tenantId', this.tenantId);
        if(filter != null){
            /*if(filter.activityType && filter.activityType !== IActivityType.All){
                options.addFilter('match', 'activityType', filter.activityType);
            }
            if(filter.contentId){
                options.addFilter('match', 'content.uid', filter.contentId );
            }
            if(filter.customerId){
                options.addFilter('match', "secondaryActors.uid", filter.customerId);
            }
            if(filter.timeline){
                const rangeOption = this.getDateRangeOption(filter.timeline);
                options.addFilter('range', 'time', rangeOption);
            }*/
        }
        
        
        const opt = options.size(rowsPerPage).from(rowsPerPage*pageNumber).build();
        
        return axios.post(API_HOST + '/activities/activity/_search', opt);
    }

    private getDateRangeOption(timeline: string){
        let ret = {};
        if(timeline === 'Today'){
            ret = {
                gte: moment().startOf('day').unix(),
                lte: moment().unix()
            };
        }else if(timeline === 'Yesterday'){
            ret = {
                gte: moment().subtract(1,'days').startOf('day').unix(),
                lte: moment().unix()
            };
        }else if(timeline === '7days'){
            ret = {
                gte: moment().subtract(7,'days').startOf('day').unix(),
                lte: moment().unix()
            };
        }else if(timeline === '15days'){
            ret = {
                gte: moment().subtract(15,'days').startOf('day').unix(),
                lte: moment().unix()
            };
        }else if(timeline === '30days'){
            ret = {
                gte: moment().subtract(30,'days').startOf('day').unix(),
                lte: moment().unix()
            };
        }
        
        return ret;
    }
    
}